import { render } from "./SolrAutocomplete.vue?vue&type=template&id=55eb5dc8&ts=true"
import script from "./SolrAutocomplete.vue?vue&type=script&lang=ts"
export * from "./SolrAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/janvodila/Sites/semperit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__